// extracted by mini-css-extract-plugin
module.exports = {"submit":"SubmitBtn_submit__xrSaC","confirm":"SubmitBtn_confirm__xS2zZ","disabled":"SubmitBtn_disabled__O9jiW","text":"SubmitBtn_text__E64Gg"};